import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
  selector: 'app-data-protection-consent',
  templateUrl: './data-protection-consent.component.html',
  styleUrls: ['./data-protection-consent.component.css']
})
export class DataProtectionConsentComponent {
  @Input() checked = false;

  /**
   * Al llamarse checkedChange permite utilizar:
   * [(checked)]="propiedad"
   */
  @Output() checkedChange = new EventEmitter<boolean>();

  @Output() policyClick = new EventEmitter<void>();

  readonly checkboxId = 'data-protection-authorization';

  onCheckboxChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.checked;

    this.checked = value;
    this.checkedChange.emit(value);
  }

  onPolicyClick(): void {
    this.policyClick.emit();
  }
}